export default "__VITE_ASSET__MbbbzOlB__"